import React, { useEffect } from 'react';

import { vestResolver } from '@hookform/resolvers/vest';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { create, enforce, test } from 'vest';

import {
  forgotPassword,
  resetPasswordState,
  selectError,
  selectLoading,
  selectSuccess
} from '../slice';
import ForgotPassword from './ForgotPassword';

const validationSuite = create((data = {}) => {
  test('email', 'Email is required', () => {
    enforce(data.email).isNotEmpty();
  });
});

const ForgotPasswordContainer = () => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: vestResolver(validationSuite)
  });
  const dispatch = useDispatch();

  const isSuccess = useSelector(selectSuccess);

  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        dispatch(resetPasswordState());
      }, 5000);
    }
  }, [isSuccess, dispatch]);

  const onSubmit = (data) => {
    // Handle form submission
    const { email } = data;
    dispatch(forgotPassword(email));
  };

  const pending = useSelector(selectLoading);
  const apiError = useSelector(selectError);

  return (
    <ForgotPassword
      register={register}
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
      errors={errors}
      pending={pending}
      // submitted={isSuccess}
      apiError={apiError}
    />
  );
};

export default ForgotPasswordContainer;
